import type { MangoQuery } from "rxdb"
import type { Insulin } from "src/types"

const defaultSelector = {}

// adds "is_deleted" selector to insulin query
export function createInsulinQueryObject({
  selector,
  sort,
  limit,
}: MangoQuery<Insulin>): MangoQuery<Insulin> {
  return {
    selector: {
      ...(selector ?? defaultSelector),
      $or: (selector?.$or ?? []).concat([
        { is_deleted: { $eq: false } },
        { is_deleted: { $exists: false } },
      ]),
    },
    sort,
    limit,
  }
}
